var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { ButtonLink, Col, Row } from 'grilnica-reactstrap';
var ForbiddenPage = /** @class */ (function (_super) {
    __extends(ForbiddenPage, _super);
    function ForbiddenPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ForbiddenPage.prototype.render = function () {
        return (React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 5, className: 'd-flex align-items-center justify-content-center' }),
            React.createElement(Col, { xs: 12, md: 7, className: 'd-flex flex-column align-items-start justify-content-center' },
                React.createElement("h2", { className: 'mb-primary' }, "\u0423\u041F\u0421, \u043F\u043E\u0445\u043E\u0436\u0435 \u0443 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043F\u0440\u0430\u0432 \u043D\u0430 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B."),
                React.createElement(ButtonLink, { to: '/', color: 'primary' }, "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E"))));
    };
    return ForbiddenPage;
}(Component));
export default ForbiddenPage;
//# sourceMappingURL=ForbiddenPage.js.map